
import { useState, useRef, useEffect } from "react"
import { GeoJSON } from 'react-leaflet/GeoJSON';
import { useMapEvent, useMapEvents } from 'react-leaflet/hooks'
import axios from 'axios';
import L from "leaflet";
import {
    MapContainer, TileLayer, LayersControl,
    WMSTileLayer, ScaleControl,
    Marker,
} from 'react-leaflet';
import { divIcon } from "leaflet";
import { renderToStaticMarkup } from "react-dom/server";
import MarkerClusterGroup from "react-leaflet-cluster";
import * as turf from "@turf/turf";
import Table from 'react-bootstrap/Table';
import de9im from 'de9im'
import {
    Map,
    NavigationControl,
    FullscreenControl,
    GeolocateControl,
    Source,
    Layer,
    useMap,
    Popup
} from 'react-map-gl/maplibre';

const GoldFinderGeoserver = axios.create({
    baseURL: process.env.REACT_APP_GOLD_FINDER_GEOSERVER
})

function queryGraticlesWFS(map, setGraticlesGeoJSON) {
    GoldFinderGeoserver.get("/ne/ows?", {
        params: {
            service: 'WFS',
            version: '1.0.0',
            request: 'GetFeature',
            typeNames: 'ne:wa_graticules',
            maxFeatures: 99999,

            outputFormat: 'application/json',
            srs: 'EPSG:4326',
            bbox: map.getBounds().toBBoxString()
        }
    }).then((e) => {
        setGraticlesGeoJSON(e.data);
    })
};

export function queryGraticlesWFSLibre(bboxstr, setGraticlesGeoJSON) {
    GoldFinderGeoserver.get("/ne/ows?", {
        params: {
            service: 'WFS',
            version: '1.0.0',
            request: 'GetFeature',
            typeNames: 'ne:wa_graticules',
            maxFeatures: 99999,

            outputFormat: 'application/json',
            srs: 'EPSG:4326',
            bbox: bboxstr
        }
    }).then((e) => {
        setGraticlesGeoJSON(e.data);
    })
};


export function queryGraticlesWFSLibreWithPolygonFilter(bboxstr, setGraticlesGeoJSON, polygon) {
    GoldFinderGeoserver.get("/ne/ows?", {
        params: {
            service: 'WFS',
            version: '1.0.0',
            request: 'GetFeature',
            typeNames: 'ne:wa_graticules',
            maxFeatures: 99999,

            outputFormat: 'application/json',
            srs: 'EPSG:4326',
            bbox: bboxstr
        }
    }).then((e) => {
        // e.data.features = e.data.features.filter(feature => de9im.contains(polygon, feature)|| (de9im.overlaps(polygon,feature) ))
        // intersects works well
        // e.data.features = e.data.features.filter(feature => de9im.intersects(polygon,feature)  )

        //const simpPolygon = turf.simplify(polygon, { tolerance: 0.001, highQuality: false })
        const simpPolygon = turf.transformScale(polygon, 0.9);
        e.data.features = e.data.features.filter(feature => {


            if (de9im.intersects(simpPolygon, feature)) {
                var intersection = turf.intersect(turf.featureCollection([polygon, feature]));
                if (intersection !== null) {
                    return true
                }

            }


            //const simpFeature = turf.simplify(feature, {tolerance:0.001,  highQuality:false})
            //return de9im.contains( simpPolygon, simpFeature) || de9im.overlaps( simpPolygon, simpFeature);
            //return de9im.intersects(polygon, feature)
            //return de9im.intersects(simpPolygon, feature)


        })
        //&& !de9im.disjoint(polygon,feature)

        //&& !de9im.touches(polygon,feature)
        setGraticlesGeoJSON(e.data);
    })
};




export function GraticlesOverlay({ graticlesGeoJSON, setGraticlesGeoJSON, selectedFeature, setSelectedFeature }) {
    const emptyGeoJson = {
        "type": "FeatureCollection",
        "name": "Mining_Tenements_DMIRS_003",
        "crs": { "type": "name", "properties": { "name": "urn:ogc:def:crs:EPSG::4283" } },
        "features": []
    };

    const overlayName = "1 Min Graticles Overlay";
    const [display, setDisplay] = useState(false);
    const [selectedPopup, setSelectedPopup] = useState(<></>);

    const map = useMapEvents({
        moveend() {
            if (map.getZoom() >= 11 && display) { // this is at 5km scale
                queryGraticlesWFS(map, setGraticlesGeoJSON);
            } else {
                setGraticlesGeoJSON(emptyGeoJson);
                setSelectedPopup(<></>);
            }

        },


        overlayadd(e) {

            if (e.name == overlayName) {
                setDisplay(true);
                queryGraticlesWFS(map, setGraticlesGeoJSON);
            }
        },
        overlayremove(e) {
            if (e.name == overlayName) {
                setSelectedPopup(<></>);
                setDisplay(false);
            }
        },
    });


    useEffect(() => {
        if (selectedFeature.type != undefined) {
            const centerPoint = turf.centerOfMass(selectedFeature.geometry);

            setSelectedPopup(
                <Popup autoPan={false} position={{ lat: centerPoint.geometry.coordinates[1], lng: centerPoint.geometry.coordinates[0] }}>
                    <Table striped bordered >
                        <tbody>
                            <tr>
                                <td>Map Name:</td>
                                <td>{selectedFeature.properties.map_name}</td>
                            </tr>
                            <tr>
                                <td>Map Sheet:</td>
                                <td>{selectedFeature.properties.map_sheet}</td>
                            </tr>
                            <tr>
                                <td>Block Number:</td>
                                <td>{selectedFeature.properties.block_no}</td>
                            </tr>
                            <tr>
                                <td>Primary Number:</td>
                                <td>{selectedFeature.properties.primary_no}</td>
                            </tr>
                        </tbody>
                    </Table>
                </Popup>
            );

        } else {
            setSelectedPopup(<></>);
        }
    }, [selectedFeature])



    // get a ref to the underlying L.geoJSON
    const geoJsonRef = useRef()

    // set the data to new data whenever it changes
    useEffect(() => {
        if (geoJsonRef.current) {
            geoJsonRef.current.clearLayers()   // remove old data
            geoJsonRef.current.addData(graticlesGeoJSON) // might need to be geojson.features
        }
    }, [geoJsonRef, graticlesGeoJSON])

    const onEachMinedexFeature = (feature, layer) => {
        layer.on('click', (e) => {
            setSelectedFeature(feature);
        })
    }

    return (
        <div>
            <LayersControl.Overlay name={overlayName}>

                <GeoJSON
                    ref={geoJsonRef}
                    data={graticlesGeoJSON.features}
                    onEachFeature={onEachMinedexFeature}
                />
                {selectedPopup}
            </LayersControl.Overlay>

        </div>
    )
}



export function createSingleGraticlePopupTable(graticle, latLng, setClosed) {
    return <Popup latitude={latLng.lat} longitude={latLng.lng}
        anchor="bottom"
        onClose={() => setClosed(false)}>
        <Table striped bordered style={{ marginBottom: 0 }} >
            <tbody>
                <tr>
                    <td>Map Name:</td>
                    <td>{graticle.properties.map_name}</td>
                </tr>
                <tr>
                    <td>Map Sheet:</td>
                    <td>{graticle.properties.map_sheet}</td>
                </tr>
                <tr>
                    <td>Block Number:</td>
                    <td>{graticle.properties.block_no}</td>
                </tr>
                <tr>
                    <td>Primary Number:</td>
                    <td>{graticle.properties.primary_no}</td>
                </tr>
            </tbody>
        </Table>
    </Popup >
}



export function GraticlesOverlayLibre({ graticlesGeoJSON, overlayVisibility, selectedGraticleStack }) {

    const graticleFillSelected = {
        id: 'graticle-fill-selected',
        type: 'fill',
        paint: { 'fill-color': '#000000', 'fill-opacity': 0.6 },
        layout: { visibility: `${overlayVisibility.graticles ? "visible" : "none"}` }
    };

    const graticleFill = {
        id: 'graticle-fill',
        type: 'fill',
        paint: { 'fill-color': '#000000', 'fill-opacity': 0 },
        layout: { visibility: `${overlayVisibility.graticles ? "visible" : "none"}` }
    };
    const graticleOutline = {
        id: 'graticle-outline',
        type: 'line',
        paint: { 'line-color': "#000000", 'line-width': 3 },
        layout: { visibility: `${overlayVisibility.graticles ? "visible" : "none"}` }
    };



    return <>
        <Source id="graticle" type="geojson" data={graticlesGeoJSON}>
            <Layer  {...graticleFill} />
            <Layer {...graticleOutline} />
        </Source>
        <Source id="graticle-selected" type="geojson" data={selectedGraticleStack}>
            <Layer  {...graticleFillSelected} />
        </Source>
    </>
}